<script lang="ts">
    export let fillWidth: boolean;
    export let fillHeight: boolean;
    export let imgSrc: string;
    export let altText: string;
</script>

<img class="obalImg"
     src={imgSrc}
     alt={altText}
     loading="lazy"
     class:fill-width={fillWidth}
     class:fill-height={fillHeight}>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";

    img.fill-width {
        width: 100%;
        height: auto;
    }

    img.fill-height {
        height: 100%;
        width: auto;
        margin: 0 auto;
    }

    img {
        border-radius: @border-radius-sm;
        border: 1px solid @themed-border-default;
        overflow: hidden;
    }
</style>